export default __webpack_public_path__ + "static/media/Titlebar.a7562f46.less";